export default {
    state: {
        referencias: [],
        loading: false,
        referencia_id: null,
    },
    getters: {
        loading: state => state.loading,
        referencias: (state) => state.referencias,
        referencia_id: state =>  state.referencia_id,
    },
    mutations: {
        SET_LOADING: (state, payload) => state.loading = payload,
        SET_REFERENCIAS: (state, payload) => state.referencias = payload ,
        SET_REFERENCIA_ID: (state, payload) => state.referencia_id = payload,
    },
    actions: {
        fetch({commit}, payload) {
          this.dispatch('index', payload)
            .then((response) => {
              commit('SET_REFERENCIAS', response.datos)
            })
        },
        guardarReferencia({commit}, payload) {
            return this.dispatch('store', {endpoint: 'referencia', params: payload})
        },

        eliminarReferencia({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.delete('/referencia/'+payload)
                .then(response =>
                    res(response.data)
                ).catch(error =>
                    rej(error)
                )
            });
        },

        refresh_referencias({commit}, payload) {
            commit('SET_REFERENCIAS', payload)
        },
        refreshReferenciaId({commit}, referencia_id) {
            commit('SET_REFERENCIA_ID', referencia_id);
        }
    }
}